// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2-G2n","Icon":"Languages_Icon__do4dU","LanguagesSelect":"Languages_LanguagesSelect__371kS","minimalist":"Languages_minimalist__1FryP"};